// 中铁二局配置信息
const Cdjg = {
	// 工种
	workType: ['木工', '油漆工', '钢筋工', '混凝土工', '架子工', '防水工', '抹灰工', '砌筑工', '普工', '焊工', '电工', '筑路工', '桥隧工', '水生产处理工',
		'智能楼宇管理员', '手工木工', '中央空调系统运行操作员', '建筑电工', '建筑架子工(普通脚手架)', '建筑架子工(附着升降脚手架)', '建筑起重司索信号工', '建筑起重机械司机(塔式起重机)',
		'建筑起重机械司机(施工升降机)', '建筑起重机械司机(物料提升机)', '建筑起重机械安装拆卸工(塔式起重机)', '建筑起重机械安装拆卸工(施工升降机)', '建筑起重机械安装拆卸工(物料提升机)',
		'高处作业吊篮安装拆卸工', '电焊工', '测量放线工', '通风工', '线路架设工', '塔吊司机(起重工)', '塔吊指挥(信号工)', '幕墙安装工', '石工', '涂裱工', '机械安装拆卸工', '镶嵌工',
		'机械司机', '水暖工(管道工)', '杂工', '分包管理人员', '模板工', '机动车驾驶员', '安装工', '外用电梯司机', '工长', '钢结构', '消防安装工', '土方', '植筋工', '保温', '降水',
		'人防', '电梯安装工', '二次结构', '吊车司机', '机修工', '挖机司机', '栋号长', '基坑支护', '装饰装修工', '铲车司机', '铆工', '放线工', '护坡工', '精装修工', '锚索工',
		'门窗安装工', '喷浆工', '弱电', '支护工', '桩机操作工', '加固工', '绿化工', '修理工', '修改补', '电器设备安装工', '预应力', '爆破工', '水电工', '司钻员', '强电',
		'安装钳工', '气焊气割工', '管片拼装工', '双轨梁操作手', '螺杆工', '司索工', '拌浆站操作员', '轨线工', '盾构机司机', '电机车司机', '龙门吊司机', '装载机司机', '叉车司机',
		'热处理工', '仪表工', '旋挖钻机手', '顶管工', '隔墙板工', '履带吊司机', '成槽机司机', '双轮铣司机', '布鲁克操作手', '二次注浆工', '接触网工'
	],
	// 岗位
	position: ['项目经理', '项目副经理', '执行经理', '技术负责人', '安全负责人', '安全工程师', '专职安全员', '装饰装修施工员', '设备安装施工员', '市政工程施工员', '钢筋工长',
		'木工工长', '混凝土工长', '土建质量员', '装饰装修质量员', '设备安装质量员', '市政工程质量员', '材料员', '机械员', '劳务员', '资料员', '标准员', '构件工艺员', '信息管理员',
		'构件质量检验员', '质检员', '测量员', '预算员', '试验员', '技术员', '书记', '总工', '安全总监', '商务经理', '计量员', '设备员', '调度员', '后勤', '设计单位', '保安',
		'BIM中心经理', '钢筋翻样', '副部长', '架子队队长', '常务指挥长', '副书记', '科员', '公用设备工程师', '造价工程师', '钢结构工程师', '工会主席', '总经济师', '计划员',
		'常务副经理', '供应商人员', '商务副经理', '安全监督官', '质量负责人', '生产经理', '行政文员', '业主(建设单位)', '保洁', '监督员', 'BIM工程师', '行保员', '主任',
		'架子队副队长', '商务指挥长', '工区总', '土木工程师', '建造师', '环保工程师', '电气工程师', '电工', 'BIM中心主任', '项目负责人', '质量总监', '总调度长', '副总调度长',
		'前期经理', '机修师', '库管员', '旁站员', '民管员', '财务', '监理单位', '区段长', '厨师', '经理助理', '劳资员', '部长', '主管', '指挥长', '现场指挥长', '工区长',
		'监理工程师', '机械工程师', '部门经理', '现场队长', '工程师', '机务员', '第三方监测人员', '副总经济师', '副总工'
	],
	// 注册人员类型
	userType: [{
			id: 1,
			name: '采集劳务人员'
		},
		{
			id: 2,
			name: '采集岗位人员'
		}
	],
	//  注册类型
	regType: [{
		id: 3,
		name: '人脸采集'
	}],
	// 责任主体类型
	unit_type: [{
		name: '建设单位',
		id: 'UNIT_ROLE_JSDW'
	}, {
		name: '勘察单位',
		id: 'UNIT_ROLE_KC'
	}, {
		name: '设计单位',
		id: 'UNIT_ROLE_SJ'
	}, {
		name: '审图单位',
		id: 'UNIT_ROLE_ST'
	}, {
		name: '施工总承包单位',
		id: 'UNIT_ROLE_SG'
	}, {
		name: '监理单位',
		id: 'UNIT_ROLE_JL'
	}, {
		name: '检测机构',
		id: 'UNIT_ROLE_JCJG'
	}, {
		name: '招标代理',
		id: 'UNIT_ROLE_ZBDL'
	}, {
		name: '造价咨询',
		id: 'UNIT_ROLE_ZJZX'
	}, {
		name: '劳务分包单位',
		id: 'UNIT_ROLE_LWFB'
	}, {
		name: '其他',
		id: 'UNIT_ROLE_OTHER'
	}, {
		name: '专业承包单位',
		id: 'UNIT_ROLE_ZYCB'
	}, {
		name: '起重机械设备安拆',
		id: 'UNIT_ROLE_JXSBAC'
	}, {
		name: '专项勘察',
		id: 'UNIT_ROLE_ZXKC'
	}, {
		name: '专项设计',
		id: 'UNIT_ROLE_ZXSJ'
	}, {
		name: '初步勘察',
		id: 'UNIT_ROLE_CBKC'
	}, {
		name: '初步设计',
		id: 'UNIT_ROLE_CBSJ'
	}, {
		name: '商品混凝土供应企业',
		id: 'UNIT_ROLE_SH'
	}, {
		name: '专业分包单位',
		id: 'UNIT_ROLE_ZYFB'
	}]
}
export default Cdjg



// WEBPACK FOOTER //
// ./src/configure/cdjg.js